import { render } from "./ProjectButton.vue?vue&type=template&id=7c2af144&scoped=true"
import script from "./ProjectButton.vue?vue&type=script&lang=js"
export * from "./ProjectButton.vue?vue&type=script&lang=js"

import "./ProjectButton.vue?vue&type=style&index=0&id=7c2af144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2af144"]])

export default __exports__